import { ElMessageBox, ElNotification } from 'element-plus'
import type { ErrorMessageMode } from '../types/axios'
import { t } from '@/hooks/system/useVuei18n'

export function checkStatus(status: number, msg: string, errorMessageMode: ErrorMessageMode = 'message'): void {
  let errMessage = ''

  switch (status) {
    case 400:
      errMessage = `${msg}`
      break
    // 401: Not logged in
    // Jump to the login page if not logged in, and carry the path of the current page
    // Return to the current page after successful login. This step needs to be operated on the login page.
    case 401:
      errMessage = msg || t('http.401').value

      break
    case 403:
      errMessage = t('http.403').value
      break
    // 404请求不存在
    case 404:
      errMessage = t('http.404').value
      break
    case 405:
      errMessage = t('http.405').value
      break
    case 408:
      errMessage = t('http.408').value
      break
    case 500:
      errMessage = t('http.500').value
      break
    case 501:
      errMessage = t('http.502').value
      break
    case 502:
      errMessage = t('http.502').value
      break
    case 503:
      errMessage = t('http.503').value
      break
    case 504:
      errMessage = t('http.504').value
      break
    case 505:
      errMessage = t('http.505').value
      break
    default:
  }

  if (errMessage) {
    if (errorMessageMode === 'modal') {
      ElMessageBox.alert(errMessage, t('http.error').value)
    }
    else if (errorMessageMode === 'message') {
      ElNotification({
        type: 'error',
        title: errMessage,
      })
    }
  }
}
